module.exports = __webpack_public_path__ + "img/baseline-attach_file-24px.2c6e91cc.svg";